import React, { Component } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  RouteComponentProps,
  Switch,
  Redirect,
} from "react-router-dom";
import { store, persistor } from "../store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./App.scss";

import Home from "./Home";
import Produto from "./Produto";
import RecoverSenha from "./RecoverSenha";
import Login from "./Login";
import Cadastro from "./Cadastro";
import MeuCadastro from "./MeuCadastro";
import MeusPedidos from "./MeusPedidos";
import Departamento from "./Departamento";
import Pesquisa from "./Pesquisa";
import Checkout from "./Checkout";
import CheckoutPagamento from "./CheckoutPagamento";
import CheckoutFim from "./CheckoutFim";
import Central from "./Central";
import NoMatchPage from "./NoMatchPage";
import EdicaoPerfil from "./EdicaoPerfil";
import SobreNos from "./SobreNos";
import Receitas from "./Receitas";
import Dicas from "./Dicas";
import Contato from "./Contato";

class App extends Component<{}> {
  state: any = {};

  constructor(props: any) {
    super(props);
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <Switch>
              {/* DECLARA AS ROTAS USADAS NO PROJETO */}
              <Route path="/" exact component={Home} />
              <Route path="/login" exact component={Login} />
              <Route path="/cadastro" exact component={Cadastro} />
              <Route path="/meu-cadastro" exact component={MeuCadastro} />
              <Route path="/meus-pedidos" exact component={MeusPedidos} />
              <Route path="/recuperar-senha" exact component={RecoverSenha} />
              <Route path="/reset-senha" exact component={EdicaoPerfil} />
              <Route path="/editar/perfil" exact component={EdicaoPerfil} />
              <Route path="/editar/pessoal" exact component={EdicaoPerfil} />
              <Route path="/editar/endereco" exact component={EdicaoPerfil} />
              <Route path="/central-do-cliente" exact component={Central} />
              <Route path="/produto" exact component={Produto} />
              {/* <Route path="/produto/:nome/:id" exact component={Produto}/> */}
              <Route
                path="/departamento/:menu1"
                exact
                strict
                component={Departamento}
              />
              <Route
                path="/departamento/:menu1/:menu2"
                exact
                strict
                component={Departamento}
              />
              <Route
                path="/departamento/:menu1/:menu2/:menu3"
                exact
                strict
                component={Departamento}
              />
              <Route path="/busca/:termo" exact strict component={Pesquisa} />
              <Route path="/checkout" exact strict component={Checkout} />
              <Route
                path="/checkout/entrega"
                exact
                strict
                component={CheckoutPagamento}
              />
              <Route
                path="/checkout/fim"
                exact
                strict
                component={CheckoutFim}
              />
              <Route path="/receitas" exact strict component={Receitas} />
              <Route path="/dicas" exact strict component={Dicas} />
              <Route path="/sobre-nos" exact strict component={SobreNos} />
              <Route path="/contato" exact strict component={Contato} />
              <Route path="/404" exact stric component={NoMatchPage} />
              <Route path="/:nome" exact component={Produto} />
            </Switch>
          </Router>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
